import React, { useState } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ROUTE_MOBILE_VERIFICATION, ROUTE_NOMINEE_SENDOTP } from "../Routes";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "../libs/axiosConfig";
import { selectPanNumber } from "../Store/panNumberSlice";
import { selectPhoneNumber } from "../Store/MobileSlice";
import Toast from "../Components/ToastMsg/Toast";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";
import LogoutModal from "../Components/LogoutModal";
import { ToastContainer } from "react-toastify";


const NomineeGuardian = () => {


  const Navigate = useNavigate();
  const location = useLocation();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [formErrors, setFormErrors] = useState({});
  const [guardianName, setguardianName] = useState("");
  const [guardianPan, setguardianPan] = useState("");
  const [nomineeRelation, setnomineeRelation] = useState("");
  const [panValidation, setPanValidation] = useState(null);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const refreshToken = useSelector(selectRefreshToken);
  const [showModal, setShowModal] = useState(false);

  const { nomineeName } = location.state || {};
  const { nomineeRelationShip } = location.state || {};
  const { nomineeDob } = location.state || {};
  const { nomineeType } = location.state || {};


  const validatePan = (pan) => {
    const isValid = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.exec(pan);
    return isValid ? null : "Invalid PAN format";
  };


  const handleguardianNameChange = (e) => {
    const input = e.target.value;
    // Regular expression to match only alphabets
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setguardianName(input);
    }
  };

  const handleguardianPanChange = (e) => {
    const input = e.target.value.toUpperCase();
    setguardianPan(input);

    // Validate the PAN format
    setPanValidation(validatePan(input));
  };
  const handlenomineeRelationChange = (e) => {
    setnomineeRelation(e.target.value);
  };

  const handleguardianNameClear = () => {
    setguardianName("");
  };

  const handleguardianPanClear = () => {
    setguardianPan("");
  };

  const handlenomineeRelationClear = () => {
    setnomineeRelation("");
  };
  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

 let HandleSubmit = async () => {

    // if (panValidation) {
    //   console.error("Invalid PAN:", panValidation);
    //   return;
    // }

    if (!guardianName) {
      Toast.error ( "Guardian name is required");
    }
    else if (!guardianPan) {
      Toast.error ( "Guardian PAN is required");
    } else if (panValidation) {
      Toast.error ( panValidation);
    }
   

   else {

    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken

      };
      const dexterrResponse = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          CustomerKycDetails: {
            request_type: "post",
            nomineeAllocationPercentage: "100",
            nomineeName,
            nomineeRelationShip,
            nomineeDob,
            nomineeType,
            mobileNumber: phoneNumber,
            pan: panNumber,
            nomineeGuardianName: guardianName,
            nomineeGuardianPan: guardianPan
          },
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken

          },
        }
      );

      if (dexterrResponse.data.statusCode === 200) {
        // Toast.success("Dexterr API call successful", "success");

        // const secondApiResponse = await axios.post(
        //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails",
        //   {
        //     nomineeAllocationPercentage: "100",
        //     nomineeName,
        //     nomineeRelationShip,
        //     nomineeDob,
        //     nomineeType,
        //     nomineeGuardianName: guardianName,
        //     nomineeGuardianPan: guardianPan
        //   },
        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken

        //     },
        //   }
        // );
        Navigate(ROUTE_NOMINEE_SENDOTP);
        
      } else {
        Toast.error(dexterrResponse.data.message + " " + dexterrResponse.data.errorMessage);
      }
      
    } catch (error) {
      console.error("Error:", error);
      console.error("API Response:", error.response);
      Toast.error(
        error.response.data.errorMessage +
          " " +
          error.response.data.message || "Error"
      );    }
   }
  };

  // Navigate(ROUTE_NOMINEE_SENDOTP);


  return (
    <div className="Nominee_guardian_Container">
      <div className="Nominee_guardian_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack}/>
        <div className="Dexter_logo_container">
        <img alt="" src={NewDexterLogo} className="DexterLogo"/>
        </div>
      </div>
      <div className="nominee_guardian_Proceed_Container">
        <p className="Input_Heading_text">Nominee guardian details</p>
        <span className="Input_Sub_heading">
        Almost done! Add guardian details for your  <br />
        nominee and submit.
        </span>

        {/* Bank Account Number Input */}
        <div className="nominee_guardian_Input_Filed_Box">
          <span className="Enter_guardian_text">
            Enter guardian name
          </span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.bankAccountNumber ? classes.Error : ""
                }`}
              value={guardianName}
              onChange={handleguardianNameChange}
            />

            <button
              className={classes.Cross_button}
              onClick={handleguardianNameClear}
            />
          </div>
        </div>


        <div className="nominee_guardian_Input_Filed_Box2">
          <span className="Enter_guardian_text2">Enter guardian PAN</span>
          <div className="Input_Inner_Container2">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={guardianPan}
              onChange={handleguardianPanChange}
              maxLength={10}
            />

            <button
              className={classes.Cross_button}
              onClick={handleguardianPanClear}
            />
          </div>
        </div>



        <button className="Submit_button" onClick={HandleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      <ToastContainer />
    </div>
  );
};

export default NomineeGuardian;
